import APP_Map from './class-app-map.js';

function gfi_init_maps() {
  if (!document.querySelector('.app-map')) {
    return;
  }

  window.gfi_maps = [];

  if (document.querySelector('.gfi-google-map')) {
    document.querySelectorAll(".gfi-google-map").forEach((map_element, key) => {
      window.gfi_maps.push(new APP_Map(key, map_element));
    });
  }

  // Event listeners for UI elements outside of the Google map
  if (document.querySelector('button.app-map__list-collapse')) {
    document.querySelectorAll('button.app-map__list-collapse').forEach(elem => {
      elem.addEventListener('click', () => {
        elem.closest('.app-map__list').classList.toggle('-collapsed');
      })
    });
  }

  if (document.querySelector('button.app-map__list-item-title')) {
    document.querySelectorAll('button.app-map__list-item-title').forEach(elem => {
      elem.addEventListener('click', () => {
        let map_id = elem.closest('.app-map').dataset.id,
            list_id = elem.closest('.app-map__list-item').dataset.id;

        window.gfi_maps[map_id].goto_marker(list_id);
      })
    });
  }

  // Search UI listeners
  if (document.querySelector('.app-map__search')) {
    document.querySelectorAll('.app-map__search').forEach(elem => {
      elem.addEventListener('submit', (e) => {
        e.preventDefault(); 
        let id = elem.closest('.app-map').dataset.id,
            search_term = elem.querySelector('.app-map__search-input').value,
            country = Array.from(elem.querySelector('.app-map__search-input-countries').selectedOptions,e=>e.value),
            status = Array.from(elem.querySelector('.app-map__search-input-status').selectedOptions,e=>e.value);

        window.gfi_maps[id].filter(search_term, country, status);
      });
    });
  }

  if (document.querySelector('.app-map__search-input-countries')) {
    document.querySelectorAll('.app-map__search-input-countries').forEach(elem => {
      elem.addEventListener('change', () => {
        let parent = elem.closest('.app-map__search'),
            id = parent.closest('.app-map').dataset.id,
            search_term = parent.querySelector('.app-map__search-input').value,
            country = Array.from(parent.querySelector('.app-map__search-input-countries').selectedOptions,e=>e.value),
            status = Array.from(parent.querySelector('.app-map__search-input-status').selectedOptions,e=>e.value);

        window.gfi_maps[id].filter(search_term, country, status);
      });
  });

  if (document.querySelector('.app-map__search-input-status')) {
      document.querySelectorAll('.app-map__search-input-status').forEach(elem => {
        elem.addEventListener('change', () => {
          let parent = elem.closest('.app-map__search'),
              id = parent.closest('.app-map').dataset.id,
              search_term = parent.querySelector('.app-map__search-input').value,
              country = Array.from(parent.querySelector('.app-map__search-input-countries').selectedOptions,e=>e.value),
              status = Array.from(parent.querySelector('.app-map__search-input-status').selectedOptions,e=>e.value);

          window.gfi_maps[id].filter(search_term, country, status);
        });
      });
    }
  }

  if (document.querySelector('.app-map__clear-filters')) {
    document.querySelectorAll('.app-map__clear-filters').forEach(elem => {
      elem.addEventListener('click', () => {
        let parent = elem.closest('.app-map');

        parent.querySelector('.app-map__search-input').value = '';
        let countries = parent.querySelector('.app-map__search-input-countries').options;
        let status = parent.querySelector('.app-map__search-input-status').options;

        for (let i = 0; i < countries.length; i++) {
          countries[i].selected = false;
        }

        for (let i = 0; i < status.length; i++) {
          status[i].selected = true;
        }

        parent.querySelector('.fselect-countries .fs-label').innerText = "Select...";
        parent.querySelectorAll('.fselect-countries .fs-option').forEach(elem => {
          elem.classList.remove('selected');
        });

        window.gfi_maps[parent.dataset.id].filter('', [], []);
      });
    });
  }

  if (document.querySelector('.app-map__user-location')) {
    document.querySelectorAll('.app-map__user-location').forEach(elem => {
      elem.addEventListener('click', () => {
        let parent = elem.closest('.app-map');

        window.gfi_maps[parent.dataset.id].get_user_location();
      });
    });
  }
}

window.addEventListener('load', gfi_init_maps);